{
  "processing": "Đang xử lý xác minh...",
  "loadingIframe": "Đang tải xác minh danh tính...",
  "issueTitle": "Sự cố xác minh danh tính",
  "notConfigured": "Xác minh danh tính chưa được cấu hình đúng cho kho hàng này.",
  "notSuccessful": "Xác minh danh tính không thành công. Vui lòng thử lại hoặc liên hệ kho hàng.",
  "couldNotCompleteProceed": "Không thể hoàn tất xác minh danh tính, nhưng bạn vẫn có thể tiếp tục check-in.",
  "processFailed": "Xử lý xác minh danh tính thất bại. Vui lòng thử lại.",
  "processingFailedProceed": "Quá trình xử lý xác minh danh tính thất bại, nhưng bạn vẫn có thể tiếp tục check-in.",
  "genericError": "Đã xảy ra lỗi trong quá trình xác minh danh tính. Vui lòng thử lại.",
  "issueProceed": "Xác minh danh tính gặp sự cố, nhưng bạn vẫn có thể tiếp tục check-in.",
  "requiredTryAgain": "Cần xác minh danh tính để hoàn tất check-in. Vui lòng thử lại.",
  "checkInFailedTitle": "Không thể check-in",
  "checkInFailedMessage": "Không thể xác thực giấy tờ tùy thân của bạn"
}
